"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NON_BILLABLE_FLUX_USER_UIDS = exports.ANON_ROLE_UID = void 0;
/**
 * This identifier is used in stored document roles to represent the permission
 * level of an anonymous user
 *
 * Not sure where it originally came from
 *
 * NOTE: that this is a hardcoded value in the firestore security rules!
 */
exports.ANON_ROLE_UID = "0338f920-f103-45be-9462-2cae879caa37";
/**
 * List of Flux user UIDs that should not count towards billable editor counts
 */
exports.NON_BILLABLE_FLUX_USER_UIDS = ["dQV3OMncTEVcOpwIwe1ivV70My52"];
//# sourceMappingURL=permission.js.map